import { ITicketStatus } from "app/types";
import {
  ActivityGroup,
  MyTicket,
  ProjectProgress,
  TicketStatusWidget,
} from "./type";

export interface MyTicketsHeader {
  id: string;
  name: string;
  sortable: boolean;
  sortOrder: "asc" | "desc";
}

export const widgetData: TicketStatusWidget[] = [
  {
    title: "To do",
    data: [
      { name: "Opened", value: 2, color: "#FBbf24" },
      { name: "Reopened", value: 1, color: "#F97316" },
      { name: "Not started", value: 2, color: "#9CA3AF" },
    ],
  },
  {
    title: "In process",
    data: [
      { name: "Triaged", value: 2, color: "#22C55E" },
      { name: "In Review", value: 1, color: "#38BDF8" },
      { name: "In staging", value: 2, color: "#A855F7" },
    ],
  },
  {
    title: "Done",
    data: [
      { name: "Completed", value: 2, color: "#16A34A" },
      { name: "Verified", value: 1, color: "#0891B2" },
      { name: "Closed", value: 2, color: "#374151" },
    ],
  },
];

export const myTicketsHeaders: MyTicketsHeader[] = [
  { id: "title", name: "Ticket Name", sortable: true, sortOrder: "asc" },
  { id: "project", name: "Project", sortable: true, sortOrder: "asc" },
  { id: "status", name: "Status", sortable: true, sortOrder: "asc" },
  { id: "dueDate", name: "Due Date", sortable: true, sortOrder: "asc" },
  { id: "effortEstimated", name: "Estimate", sortable: true, sortOrder: "asc" },
  { id: "effortActual", name: "Actual", sortable: true, sortOrder: "asc" },
];

export const timeLogEntries = [
  {
    id: 1,
    date: "23 Nov, 2024",
    time: "9:00 am - 5:15 pm",
    duration: "8h 15m",
  },
  {
    id: 2,
    date: "23 Nov, 2024",
    time: "9:00 am - 5:10 pm",
    duration: "8h 10m",
  },
];

export const statusOptions: ITicketStatus[] = [
  { _id: "Opened", name: "Opened", color: "#F59E0B" },
  { _id: "In review", name: "In review", color: "#0EA5E9" },
  { _id: "Reopened", name: "Reopened", color: "#EF4444" },
  { _id: "Not started", name: "Not started", color: "#9CA3AF" },
  { _id: "Completed", name: "Completed", color: "#16A34A" },
];
